export default "__VITE_ASSET__Dg9eUD1R__"